/**
 * Gemeinsame Beschriftung und Farbe der fünf Status der Differenzansicht
 * Zuständigkeit (AP8, schnittstelle.md/plan.md E16) - eine Quelle für
 * Kennzahlen-Kacheln, Filterleiste und Tabelle.
 */
export const STATUS_FEHLT_IN_WECLAPP = "fehlt_in_weclapp";
export const STATUS_WEICHT_AB = "weicht_ab";
export const STATUS_EHEMALIG = "ehemalig";
export const STATUS_OHNE_ZUORDNUNG = "ohne_zuordnung";
export const STATUS_NUR_WECLAPP = "nur_weclapp";
export const STATUS_GLEICH = "gleich";

// Reihenfolge wie in der Rückgabe des Servers: auffällige Status zuerst,
// "gleich" zuletzt.
export const STATUS_ORDER = [
    STATUS_FEHLT_IN_WECLAPP,
    STATUS_WEICHT_AB,
    STATUS_EHEMALIG,
    STATUS_OHNE_ZUORDNUNG,
    STATUS_NUR_WECLAPP,
    STATUS_GLEICH,
];

// Standardauswahl beim ersten Öffnen der Seite (ohne Status-Parameter in der
// URL): nur die auffälligen Status, die einen Handlungsbedarf anzeigen.
// "gleich" und "nur_weclapp" bleiben per Klick auf die Kennzahl-Kachel bzw.
// im Statusfilter zuschaltbar.
export const STANDARD_STATUS_FILTER = [STATUS_FEHLT_IN_WECLAPP, STATUS_WEICHT_AB, STATUS_EHEMALIG, STATUS_OHNE_ZUORDNUNG];

const STATUS_META = {
    [STATUS_FEHLT_IN_WECLAPP]: {
        label: "Fehlt in weclapp",
        variant: "danger",
        description:
            "Die Vorlage nennt einen Vertreter, im weclapp-Kundenstamm ist beim Kunden kein Kundenverantwortlicher eingetragen.",
    },
    [STATUS_WEICHT_AB]: {
        label: "Weicht ab",
        variant: "warning",
        description: "Vorlage und weclapp nennen verschiedene Vertreter.",
    },
    [STATUS_EHEMALIG]: {
        label: "Ehemalig",
        variant: "secondary",
        description: "Die Zuordnung zeigt auf einen ausgeschiedenen Mitarbeiter (z. B. JW, NK).",
    },
    [STATUS_OHNE_ZUORDNUNG]: {
        label: "Nicht zugeordnet – prüfen",
        variant: "dark",
        description: "Der Kunde hatte Umsatz, aber weder Vorlage noch weclapp nennen einen Vertreter.",
    },
    [STATUS_NUR_WECLAPP]: {
        label: "Nur weclapp",
        variant: "info",
        description: "In weclapp ist ein Kundenverantwortlicher eingetragen, die Vorlage kennt den Kunden nicht.",
    },
    [STATUS_GLEICH]: {
        label: "Gleich",
        variant: "success",
        description: "Excel-Vorlage (Fassung Oscar, 09.09.2026) und weclapp nennen denselben Vertreter.",
    },
};

export function statusLabel(status) {
    return STATUS_META[status]?.label || status;
}

export function statusVariant(status) {
    return STATUS_META[status]?.variant || "secondary";
}

export function statusDescription(status) {
    return STATUS_META[status]?.description || null;
}
